import React, { useContext, useEffect } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import HTMLReactParser from 'html-react-parser';
import './home.css';
import { useGlobal } from '../../utils/GlobalContext';

export default function JumbotronComponent() {
  const { state } = useGlobal();
  return (
    <Card sx={{ minWidth: 275 }} style={{ border: 'none', boxShadow: 'none' }}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <div className='LeftPart'>
              <Typography variant='h5' fontWeight='bold'>
                {state.Conference.Name}
              </Typography>
              <>
              <br/>
              <Typography variant='body1'></Typography>
              <Typography variant='body2'>
                {state.Conference.Address1}<br/>
                {state.Conference.City}, {state.Conference.State}
              </Typography></>
              <br/>
              <Typography variant='body2'>
                {HTMLReactParser(state.Conference.Description.toString() ?? "")}
              </Typography>
            </div>
          </Grid>
          <Grid className='jumbotron' item xs={12} md={6} container justifyContent='flex-end'>
            <img alt='Site Logo' className='jumbotronImage' src={state.Conference.Image} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}